<div class="scrolling-bar_bar-area">
    <div class="scrolling-bar_bar" #bar></div>
</div>
